import MPagesBuilder from './builder'
import MPages from './m-pages'
export { MPagesBuilder, MPages }
export default { MPagesBuilder, MPages }
